var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "title-wrapper" }, [_vm._v(" 转账 ")]),
      _c(
        "el-form",
        {
          ref: "addContactForm",
          attrs: { rules: _vm.rules, model: _vm.addContactList },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "联系人名称", prop: "Name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人名称" },
                model: {
                  value: _vm.addContactList.Name,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "Name", $$v)
                  },
                  expression: "addContactList.Name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.Phone"), prop: "IPhone" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人手机号" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.IPhone = _vm.trimFormat(
                      _vm.addContactList.IPhone
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.IPhone,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "IPhone", $$v)
                  },
                  expression: "addContactList.IPhone",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.Email"), prop: "Email" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人邮箱" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.Email = _vm.trimFormat(
                      _vm.addContactList.Email
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.Email,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "Email", $$v)
                  },
                  expression: "addContactList.Email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "PanNo", prop: "PanNo" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人PanNo" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.PanNo = _vm.trimFormat(
                      _vm.addContactList.PanNo
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.PanNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "PanNo", $$v)
                  },
                  expression: "addContactList.PanNo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "身份证账号", prop: "IFSCCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人身份证账号" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.IFSCCode = _vm.trimFormat(
                      _vm.addContactList.IFSCCode
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.IFSCCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "IFSCCode", $$v)
                  },
                  expression: "addContactList.IFSCCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "银行名称", prop: "BankName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人银行名称" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.BankName = _vm.trimFormat(
                      _vm.addContactList.BankName
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.BankName,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "BankName", $$v)
                  },
                  expression: "addContactList.BankName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "vpa", prop: "vpa" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人vpa" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.vpa = _vm.trimFormat(
                      _vm.addContactList.vpa
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.vpa,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "vpa", $$v)
                  },
                  expression: "addContactList.vpa",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "银行账户", prop: "BankAccountNo" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人银行账户" },
                on: {
                  blur: function ($event) {
                    _vm.addContactList.BankAccountNo = _vm.trimFormat(
                      _vm.addContactList.BankAccountNo
                    )
                  },
                },
                model: {
                  value: _vm.addContactList.BankAccountNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "BankAccountNo", $$v)
                  },
                  expression: "addContactList.BankAccountNo",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系地址", prop: "Address" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人联系地址" },
                model: {
                  value: _vm.addContactList.Address,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "Address", $$v)
                  },
                  expression: "addContactList.Address",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系人的别名" },
                model: {
                  value: _vm.addContactList.Remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.addContactList, "Remark", $$v)
                  },
                  expression: "addContactList.Remark",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$router.back()
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.addSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }